import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {map} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {Order} from '../shared/order.model';
import {FilterDate} from '../shared/filterDate.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  urlManageOrder = environment.api.order;
  urlGetOrder = environment.api.orderGet;
  urlGetOrdersByUserId = environment.api.getOrdersByUserId;
  urlReportOrder = environment.api.reportOrder;

  constructor(private http: HttpClient) {
  }

  addOrder(data: Order) {
    return this.http.post(this.urlManageOrder, data)
      .pipe(map(results => results));
  }

  getOrdersByUserId(userId: string, data: FilterDate) {
    let params = new HttpParams();
    params = params.append('startDate', data.startDate);
    params = params.append('endDate', data.endDate);
    const url = this.urlGetOrdersByUserId.replace('{userId}', userId);
    return this.http.get(url, {params}).pipe(map(results => results));
  }

  getOrdersById(orderId: string) {
    const url = this.urlGetOrder.replace('{orderId}', orderId);
    return this.http.get(url).pipe(map(results => results));
  }

  updateOrder(data: Order) {
    return this.http.put(this.urlManageOrder, data)
      .pipe(map(results => results));
  }

  reportOrder(userId: string, data: FilterDate) {
    let params = new HttpParams();
    params = params.append('startDate', data.startDate);
    params = params.append('endDate', data.endDate);
    const url = this.urlReportOrder.replace('{userId}', userId);
    return this.http.get(url, {params}).pipe(map(results => results));
  }



}
